import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PrSelectSearchComponent } from './pr-select-search.component';

@NgModule({
  imports: [CommonModule, FormsModule, MatSelectModule, MatTooltipModule],
  exports: [PrSelectSearchComponent],
  declarations: [PrSelectSearchComponent],
})
export class PrSelectSearchModule {}
